<template>
  <v-card class="sellerManagement" flat>

    <v-btn fixed right bottom icon x-large class="indigo" style="z-index: 1" to="/admin/newSeller">
      <v-icon color="white">fa-plus</v-icon>
    </v-btn>
    
    <AdminToolbar
      :searchTypes="searchTypes" 
      :search_condition.sync="search_condition"
      :sortTypes="sortTypes"
      :sort.sync="sort"
      :tabs="tabs"
      :tab.sync="tab"
      @searching="searching"
    ></AdminToolbar>

    <div class="table" v-infinite-scroll="getSellers" infinite-scroll-disabled="busy" infinite-scroll-distance="150">
      <v-row class="table-header" no-gutters>
        <v-col>主播</v-col>
        <v-col>編號</v-col>
        <v-col>本名</v-col>
        <v-col>手機</v-col>
        <v-col>Line</v-col>
        <v-col>Email</v-col>
        <v-col>身高</v-col>
        <v-col>體重</v-col>
        <v-col>三圍</v-col>
        <v-col>職業</v-col>
        <v-col>所屬經紀</v-col>
        <v-col>銀行名稱</v-col>
        <v-col>銀行分行</v-col>
        <v-col>銀行帳號</v-col>
        <v-col>建立時間</v-col>
        <v-col>最後上線時間</v-col>
        <v-col>停用狀態</v-col>
        <v-col style="min-width: 100px; max-width: 100px"></v-col>
      </v-row>

      <div class="table-body">
        <v-row class="table-content" no-gutters v-for="seller in sellers">
          <v-col>
            <v-avatar size="40" class="mr-2">
              <v-img :src="$HOST_URL + seller.usericon"/>
            </v-avatar>
              {{ seller.nickname }}
          </v-col>
          <v-col>
            {{ seller.id | seller }}
          </v-col>
          <v-col>
            {{ seller.last_name }}{{ seller.first_name }}
          </v-col>
          <v-col>
            {{ seller.tel }}
          </v-col>
          <v-col>
            {{ seller.line }}
          </v-col>
          <v-col>
            {{ seller.email }}
          </v-col>
          <v-col>
            {{ seller.height }} cm
          </v-col>
          <v-col>
            {{ seller.weight }} kg
          </v-col>
          <v-col>
            {{ `${seller.bust}${seller.cup} / ${seller.waist} / ${seller.hips}` }} 
          </v-col>
          <v-col>
            {{ seller_job_types.find(job => job.num == seller.job).name }}
          </v-col>
          <v-col>
            
          </v-col>
          <v-col>
            {{ seller.bank }}
          </v-col>
          <v-col>
            {{ seller.bank_branch }}
          </v-col>
          <v-col>
            {{ seller.account_number }}
          </v-col>
          <v-col>
            {{ seller.created_at | formatDate }}
          </v-col>
          <v-col>
            {{ seller.last_up_time ? (seller.last_up_time | formatDate) : '' }}
          </v-col>
          <v-col>
            <v-btn 
              v-if="seller.disabled" 
              icon 
              color="red" 
              @click="$refs.reasonDialog.submit(reason => ban(seller, false, reason))"
            >
              <v-icon>fa-ban</v-icon>
            </v-btn>
            <v-btn 
              v-else 
              icon 
              color="success" 
              @click="$refs.reasonDialog.submit(reason => ban(seller, true, reason))"
            >
              <v-icon>fa-check</v-icon>
            </v-btn>
          </v-col>
          <v-col style="min-width: 100px; max-width: 100px">
            <v-btn 
              icon 
              color="indigo" 
              :to="`/admin/seller/${seller.id}`"
            >
              <v-icon>fa-edit</v-icon>
            </v-btn>
            <v-btn 
              icon 
              color="red" 
              @click="$root.$emit('confirmDialog', () => deleteSeller(seller), '該操作不可復原', 'far fa-times-circle', 'red')"
            >
              <v-icon>fa-trash-alt</v-icon>
            </v-btn>
          </v-col>
        </v-row>
      </div>
    </div>
    <ReasonDialog ref="reasonDialog"></ReasonDialog>
  </v-card>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import AdminToolbar from '@/components/admin/AdminToolbar'
import ReasonDialog from '@/components/ReasonDialog'
export default {
  components: { AdminToolbar, ReasonDialog },
  data() {
    return {
      busy: false,
      page: 1,
      searchTypes: [
        { text: '主播暱稱', table: 'sellers', column: 'nickname' },
        { text: '職業', table: 'sellers', column: 'job' },
        { text: 'Email', table: 'sellers', column: 'email' },
        { text: '手機', table: 'sellers', column: 'tel' },
      ],
      sortTypes: [
        { text: '建立日期', table: 'products', column: 'created_at', by: 'desc' },
        { text: '總售出', table: 'sellers', column: 'sold', by: 'desc' },
        { text: '總銷售額', table: 'sellers', column: 'price', by: 'desc' },
      ],
      sort: null,
      tabs: [],
      tab: 0,
      search_condition: [],
      sellers: []
    }
  },
  computed: {
    ...mapState('global', ['seller_job_types']),
  },
  methods: {
    searching() {
      this.busy = false
      this.page = 1
      this.sellers = []
      this.getSellers()
    },
    deleteSeller(seller) {
      this.axios.delete(`/admin/sellers`, {
        data: {
          id: [seller.id]
        }
      }).then(response => {
        this.sellers.splice(this.sellers.indexOf(seller), 1)
        this.$root.$emit('alert', 'success', '刪除成功')
      }).catch(() => {
        this.$root.$emit('alert', 'error', '刪除失敗')
      })
    },
    getSellers() {
      this.busy = true
      this.axios.post('/admin/sellers', {
        search: this.search_condition,
        page: this.page,
        size: 50,
        sort: this.sort || null,
      }).then(response => {
        this.sellers = this.sellers.concat(response.data.data)
        if(this.page != response.data.last_page) {
          this.page += 1
          this.busy = false
        }
      })
    },
    ban(seller, disabled, reason) {
      this.axios.post(`${disabled ? '/admin/ban' : '/admin/lift/ban'}`,{
        type: 'seller',
        id: seller.id,
        reason: reason
      }).then(response => {
        seller.disabled = !seller.disabled
        this.$root.$emit('alert', 'success', '修改成功')
      }).catch(() => {
        this.$root.$emit('alert', 'error', '修改失敗')
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.sellerManagement {
  .table-body {
    .col {
      &.checkbox {
        max-width: 24px;
        .v-input--selection-controls {
          margin: 0;
          padding: 0;
        }
      }
    }
  }
}
</style>